import { FormConfig } from '../../../../components/Form';

export const CREATE_MESSAGE_FORM_CONFIG: FormConfig = {
  title: {
    label: 'Heading',
    placeholder: 'Enter message heading',
    fieldType: 'text',
    required: true,
    validations: {
      required: {
        errorText: 'Please enter a heading!',
      },
    },
  },
  content: {
    label: 'Text',
    placeholder: 'Enter text message',
    fieldType: 'textarea',
    required: true,
    validations: {
      required: {
        errorText: 'Please enter a text!',
      },
    },
  },
  buttonName: {
    label: 'Button Name',
    placeholder: 'Enter button name',
    fieldType: 'text',
    required: true,
    validations: {
      required: {
        errorText: 'Please enter a button name!',
      },
    },
  },
  buttonAction: {
    label: 'Button URL',
    placeholder: 'Enter button URL',
    fieldType: 'text',
    required: true,
    validations: {
      required: {
        errorText: 'Please enter a button URL!',
      },
    },
  },
  linkName: {
    label: 'Secondary button name (optional)',
    placeholder: 'Enter button name',
    fieldType: 'text',
  },
  linkAction: {
    label: 'Secondary button URL (optional)',
    placeholder: 'Enter button URL',
    fieldType: 'text',
  },
  startDate: {
    label: 'Start date',
    placeholder: 'Enter start date',
    fieldType: 'date',
    required: true,
    customDateFormat: 'dd MMM yyyy',
    validations: {
      required: {
        errorText: 'Please enter a start date!',
      },
    },
  },
  startTime: {
    label: 'Start Time',
    placeholder: 'Enter start time',
    fieldType: 'date',
    required: true,
    showTimeSelect: true,
    showTimeSelectOnly: true,
    timeIntervals: 60,
    customDateFormat: 'HH:mm',
    validations: {
      required: {
        errorText: 'Please enter a start time!',
      },
    },
  },
  endDate: {
    label: 'End date',
    placeholder: 'Enter end date',
    fieldType: 'date',
    required: true,
    customDateFormat: 'dd MMM yyyy',
    validations: {
      required: {
        errorText: 'Please enter an end date!',
      },
    },
  },
  endTime: {
    label: 'End Time',
    placeholder: 'Enter end time',
    fieldType: 'date',
    required: true,
    showTimeSelect: true,
    showTimeSelectOnly: true,
    timeIntervals: 60,
    customDateFormat: 'HH:mm',
    validations: {
      required: {
        errorText: 'Please enter an end time!',
      },
    },
  },
};
